import { Drawer } from "@mantine/core";
import { FC } from "react";
import FunnelMenu from "../FunnelMenu";
import { FilterControl } from "../FunnelMenu/FiltersPanel";
import { ColorType } from "../FunnelMenu/ColorsPanel";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilter: (f: FilterControl) => void;
  onApplyColor: (c?: ColorType) => void;
  initFilterControl?: FilterControl;
  initColor?: ColorType;
}

const FunnelModal: FC<Props> = ({ 
  isOpen, 
  onClose, 
  onApplyFilter, 
  onApplyColor,
  initFilterControl, 
  initColor 
}) => {
  return (
    <Drawer
      opened={isOpen}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => {
        onClose();
      }}
      position="bottom"
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <FunnelMenu
        initColor={initColor}
        initFilterControl={initFilterControl}
        onApplyColor={onApplyColor}
        onApplyFilter={onApplyFilter}
        onClose={onClose}
      />
    </Drawer>
  );
};

export default FunnelModal;